<blaze-panel>
  <button icon class="icon-back" blazeIconButton (click)="showPrevPage.emit()">
    <mat-icon svgIcon="icon_chevron_left_16" />
  </button>

  <ng-container title>
    <div class="label">Choose [{{ connectorName }}] Data Sets</div>
    <div class="p-4 rounded ml-24 datasets-count">{{ selectedDatasets.size }}</div>
  </ng-container>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />

    @if (isUpdateButtonVisible) {
      <button (click)="deleteConnector()" blazeBarButton="warn-outline"> remove connector </button>
    }
    @if (isCreateButtonVisible) {
      <button
        (click)="createConnector()"
        [disabled]="isCreateButtonDisabled"
        blazeBarButton="primary"
      >
        create connector
      </button>
    }
    @if (isUpdateButtonVisible) {
      <button
        (click)="updateConnector()"
        [disabled]="isCreateButtonDisabled"
        blazeBarButton="primary"
      >
        update connector
      </button>
    }
    @if (isAddDatasetsButtonVisible) {
      <button (click)="addDatasets()" [disabled]="isCreateButtonDisabled" blazeBarButton="primary">
        {{ addDatasetsButtonLabel }}
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    <div class="mb-24 pr-8 rounded datasets-actions">
      <!-- Filtering searchbox -->
      <div class="searchbox">
        <blaze-filter-input
          (filtered)="setFilteredDatasets($event)"
          [items$]="availableDatasets$"
          [placeholder]="'Search Data Sets and Functions'"
          class="search-input"
        />
      </div>
      <!-- Select/deselect all toggle -->
      <div class="select-all">
        <mat-slide-toggle
          (change)="selectDeselectAll()"
          [(ngModel)]="areAllSelected"
          [labelPosition]="'before'"
          class="bd-toggle"
          disableRipple
        >
          Select All
        </mat-slide-toggle>
      </div>
    </div>

    <div class="datasets">
      @for (dataset of datasets$ | async; track dataset) {
        <blaze-dataset-toggle
          (changed)="updateSelectedToggles($event, dataset)"
          (showPreview)="showPreview.emit(dataset)"
          [dataset]="dataset"
          [isSelected]="isSelected(dataset)"
          class="dataset"
        />
      }
    </div>
  </div>
</blaze-panel>
